var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVeonLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.710367 2.50874L5.55796 12.9162C5.5807 12.9648 5.61682 13.006 5.66211 13.0349C5.70741 13.0638 5.75999 13.0792 5.81371 13.0793H9.89406C9.94829 13.0792 10.0014 13.0635 10.0469 13.0341C10.0924 13.0046 10.1285 12.9627 10.1508 12.9133L13.5855 5.29975C13.6081 5.24978 13.6448 5.20749 13.6911 5.17802C13.7374 5.14854 13.7912 5.13316 13.8461 5.13375L20.8332 5.2071C20.8799 5.20776 20.9257 5.21998 20.9665 5.24265C21.0073 5.26532 21.0419 5.29774 21.0671 5.33702C21.0924 5.3763 21.1075 5.42121 21.1111 5.46775C21.1148 5.5143 21.1068 5.56102 21.088 5.60375L17.0607 14.6958C17.0419 14.7376 17.0337 14.7834 17.0367 14.8292C17.0397 14.875 17.0538 14.9193 17.0779 14.9583C17.102 14.9974 17.1353 15.0299 17.1749 15.0531C17.2144 15.0763 17.2591 15.0895 17.3049 15.0914C18.7332 15.1503 23.5104 14.8666 24.736 8.59163V8.57523C25.1221 6.25904 23.7767 4.27097 23.5606 3.95057C21.8003 1.33906 18.6531 0.965574 18.2169 0.92118L17.6128 0.903809H11.8416C11.7861 0.903856 11.7319 0.920273 11.6857 0.951003C11.6395 0.981733 11.6035 1.02541 11.582 1.07656L8.42135 8.56654C8.40058 8.61639 8.36588 8.6592 8.32141 8.68983C8.27693 8.72046 8.22457 8.73762 8.17059 8.73925C8.11661 8.74088 8.0633 8.72691 8.01706 8.69902C7.97082 8.67112 7.9336 8.63049 7.90986 8.58198L4.76853 2.26457C4.7453 2.21761 4.70941 2.17808 4.66489 2.15045C4.62038 2.12283 4.56903 2.1082 4.51664 2.10823H0.965148C0.917774 2.10811 0.87114 2.11997 0.829585 2.14272C0.788029 2.16547 0.752904 2.19836 0.727476 2.23833C0.702049 2.2783 0.687146 2.32405 0.684154 2.37133C0.681163 2.41861 0.69018 2.46588 0.710367 2.50874Z",
    fill: "url(#paint0_linear_4054_16911)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9778 6.92383H18.0766C18.1472 6.92396 18.2167 6.94173 18.2786 6.97552C18.3406 7.0093 18.3931 7.05804 18.4315 7.11729C18.4698 7.17654 18.4928 7.24444 18.4982 7.31481C18.5037 7.38518 18.4915 7.4558 18.4627 7.52025L13.34 19.0095C13.3065 19.084 13.2523 19.1472 13.1839 19.1917C13.1154 19.2362 13.0356 19.26 12.954 19.2604L8.81188 19.3135C8.73237 19.3152 8.654 19.2944 8.58573 19.2536C8.51747 19.2128 8.46206 19.1537 8.42584 19.0829L6.487 15.2698C6.45358 15.2046 6.43767 15.1318 6.44082 15.0585C6.44397 14.9853 6.46608 14.9141 6.50499 14.8519C6.54389 14.7898 6.59825 14.7388 6.66277 14.704C6.72728 14.6691 6.79973 14.6516 6.87303 14.6532L10.8964 14.7265C10.9791 14.7278 11.0603 14.705 11.1301 14.6607C11.1998 14.6165 11.2552 14.5528 11.2892 14.4775L14.5927 7.17668C14.6256 7.10181 14.6794 7.03807 14.7478 6.99319C14.8161 6.94831 14.896 6.92422 14.9778 6.92383Z",
    fill: "url(#paint1_linear_4054_16911)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4054_16911",
    x1: 0.683594,
    y1: 0.903809,
    x2: 24.8052,
    y2: 0.903809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142857,
    stopColor: "#0C265B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285714,
    stopColor: "#0E2864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428571,
    stopColor: "#102B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571429,
    stopColor: "#094586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714286,
    stopColor: "#0078AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857143,
    stopColor: "#1BACCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56E1E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4054_16911",
    x1: 6.44043,
    y1: 6.92383,
    x2: 18.4995,
    y2: 6.92383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142857,
    stopColor: "#0C265B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285714,
    stopColor: "#0E2864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428571,
    stopColor: "#102B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571429,
    stopColor: "#094586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714286,
    stopColor: "#0078AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857143,
    stopColor: "#1BACCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56E1E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeonLogo2);
export default __webpack_public_path__ + "static/media/veon-logo2.a345435e766700acf2c9d55aedf6b640.svg";
export { ForwardRef as ReactComponent };